var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4C7.5 3.60218 7.65804 3.22064 7.93934 2.93934C8.22064 2.65804 8.60218 2.5 9 2.5H12.879C13.2767 2.50035 13.658 2.65862 13.939 2.94L17.061 6.06C17.2004 6.19948 17.3109 6.36506 17.3862 6.54729C17.4616 6.72952 17.5002 6.92482 17.5 7.122V13C17.5 13.3978 17.342 13.7794 17.0607 14.0607C16.7794 14.342 16.3978 14.5 16 14.5H15V11.121C14.9998 10.3254 14.6836 9.56248 14.121 9L11 5.879C10.4375 5.31635 9.67458 5.00017 8.879 5H7.5V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C4.60218 6.5 4.22064 6.65804 3.93934 6.93934C3.65804 7.22065 3.5 7.60218 3.5 8V17C3.5 17.3978 3.65804 17.7794 3.93934 18.0607C4.22064 18.342 4.60218 18.5 5 18.5H12C12.3978 18.5 12.7794 18.342 13.0607 18.0607C13.342 17.7794 13.5 17.3978 13.5 17V11.121C13.4997 10.7233 13.3414 10.342 13.06 10.061L9.94 6.939C9.80052 6.79962 9.63494 6.6891 9.45271 6.61377C9.27048 6.53844 9.07518 6.49978 8.878 6.5H5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCopyIcon);
export default __webpack_public_path__ + "static/media/whiteCopyIcon.2f3b32a8a5f4414733aba4b70fbe0df0.svg";
export { ForwardRef as ReactComponent };